import { render } from "./beautyEdu.vue?vue&type=template&id=6673b53a&scoped=true"
import script from "./beautyEdu.vue?vue&type=script&lang=js"
export * from "./beautyEdu.vue?vue&type=script&lang=js"

import "./beautyEdu.vue?vue&type=style&index=0&id=6673b53a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6673b53a"]])

export default __exports__